const SITE_URL = 'https://bukietowa.pl';

export const ORGANIZATION_ID = `${SITE_URL}/#organization`;

const openingHoursSpecification = [
  {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    opens: '09:00',
    closes: '19:00',
  },
  {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: 'Sunday',
    opens: '10:00',
    closes: '16:00',
  },
] as const;

const contact = {
  telephone: '+48 605 030 728',
  email: 'kontakt@bukietowa.pl',
} as const;

// Obie zweryfikowane placówki korzystają z jednego, wspólnego numeru kontaktowego.
export const BUKIETOWA_LOCATIONS = [
  {
    id: `${SITE_URL}/#florist-warszawska`,
    pickupName: 'Bukietowa — al. Warszawska',
    pickupHref: 'https://www.google.com/maps/dir/?api=1&destination=al.+Warszawska+23+Lublin',
    address: {
      streetAddress: 'al. Warszawska 23/1',
      postalCode: '20-803',
      addressLocality: 'Lublin',
      addressCountry: 'PL',
    },
    hasMap: 'https://share.google/c502PDedV6xZ5yxgV',
    openingHoursSpecification,
    ...contact,
  },
  {
    id: `${SITE_URL}/#florist-bursztynowa`,
    pickupName: 'Bukietowa — ul. Bursztynowa',
    pickupHref: 'https://www.google.com/maps/dir/?api=1&destination=Bursztynowa+17+Lublin',
    address: {
      streetAddress: 'ul. Bursztynowa 17/4',
      postalCode: '20-576',
      addressLocality: 'Lublin',
      addressCountry: 'PL',
    },
    hasMap: 'https://share.google/7tGEykGbvtXnJCop0',
    openingHoursSpecification,
    ...contact,
  },
] as const;

export const BUKIETOWA_ORGANIZATION = {
  '@id': ORGANIZATION_ID,
  '@type': 'Organization',
  name: 'Kwiaciarnia Bukietowa',
  legalName: 'GTH TRADE Sp. z o.o.',
  taxID: '7123457628',
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/logo.webp`,
  sameAs: [
    'https://www.facebook.com/KwiaciarniaBukietowa',
    'https://www.instagram.com/kwiaciarnia.bukietowa/',
  ],
  ...contact,
} as const;

export function buildHomepageBusinessGraph() {
  const florists = BUKIETOWA_LOCATIONS.map(({ id, pickupName: _pickupName, pickupHref: _pickupHref, ...location }) => ({
    '@id': id,
    '@type': 'Florist',
    name: 'Kwiaciarnia Bukietowa',
    parentOrganization: { '@id': ORGANIZATION_ID },
    address: { '@type': 'PostalAddress', ...location.address },
    telephone: location.telephone,
    email: location.email,
    hasMap: location.hasMap,
    openingHoursSpecification: location.openingHoursSpecification,
  }));

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@id': `${SITE_URL}/#website`,
        '@type': 'WebSite',
        url: `${SITE_URL}/`,
        name: 'Bukietowa',
        publisher: { '@id': ORGANIZATION_ID },
      },
      {
        ...BUKIETOWA_ORGANIZATION,
        department: florists.map(({ '@id': id }) => ({ '@id': id })),
      },
      ...florists,
    ],
  };
}

export const ARTICLE_PUBLISHER = {
  '@id': ORGANIZATION_ID,
  '@type': 'Organization',
  name: BUKIETOWA_ORGANIZATION.name,
  url: BUKIETOWA_ORGANIZATION.url,
  logo: BUKIETOWA_ORGANIZATION.logo,
} as const;